import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'pcln-design-system'

const SponsoredAd = ({ adId, gaIndex }) => (
  <Box mx={[2, 2, 2, 2, 0]} data-ga-index={gaIndex}>
    <div id={adId} />
  </Box>
)

SponsoredAd.propTypes = {
  gaIndex: PropTypes.number,
  adId: PropTypes.string,
}

export { SponsoredAd }
